import type { Dispatch, AnyAction } from 'redux';

import * as CreateJobTrackingTemplateAPI from 'ab-api/web/jobTracking/createJobTrackingTemplate';
import * as EditJobTrackingTemplateAPI from 'ab-api/web/jobTracking/editJobTrackingTemplate';
import * as FindJobsForTemplateAPI from 'ab-api/web/jobTracking/findJobsForTemplate';
import * as JobTrackingTableAPI from 'ab-api/web/jobTracking/findJobTrackingTemplateTable';
import * as FindJobTrackingTemplateAPI from 'ab-api/web/jobTracking/findTemplate';
import * as FindTemplatesForReportSourceAPI from 'ab-api/web/jobTracking/findTemplatesForReportSource';
import type { ReportSourceType } from 'ab-api/web/jobTracking/findTemplatesForReportSource';
import * as SetJobTrackingTemplateToJobAPI from 'ab-api/web/jobTracking/setTemplateToJob';
import * as TriggerJobTrackingResyncAPI from 'ab-api/web/jobTracking/triggerResync';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import { TableQuery } from 'ab-common/dataStructures/tableQuery';

export function findAllTemplatesForCompanyTable(tableRequestModel: TableQuery) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = new TableQuery(tableRequestModel);
			return await http.get<JobTrackingTableAPI.W_JobTracking_FindTemplateTable_VM>(JobTrackingTableAPI.URL(data));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createTemplate(data: CreateJobTrackingTemplateAPI.W_JobTracking_CreateJobTrackingTemplate_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<void>(CreateJobTrackingTemplateAPI.URL(), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function editTemplate(data: EditJobTrackingTemplateAPI.W_JobTracking_EditJobTrackingTemplate_RM, templateId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(EditJobTrackingTemplateAPI.URL(templateId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findById(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<FindJobTrackingTemplateAPI.W_JobTracking_FindById_VM>(FindJobTrackingTemplateAPI.URL(id));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function setTemplateToJob(jobId: number, templateId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(SetJobTrackingTemplateToJobAPI.URL(templateId), { jobId });
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function triggerResync(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<void>(TriggerJobTrackingResyncAPI.URL(jobId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findJobsForTemplate(templateId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindJobsForTemplateAPI.W_JobTracking_FindJobsForTemplate_VM>(FindJobsForTemplateAPI.URL(templateId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findTemplatesForReportSource(
	sourceType: ReportSourceType,
	sourceId: number
) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindTemplatesForReportSourceAPI.W_JobTracking_FindTemplatesForReportSource_VM>(
				FindTemplatesForReportSourceAPI.URL(sourceType, sourceId)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
